import { render, staticRenderFns } from "./MetricForm.vue?vue&type=template&id=4a99f7dc"
import script from "./MetricForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MetricForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MetricForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxComboboxValueOptions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/combobox-value-options.vue').default,IxBtnToggleKpiGoalType: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/ToggleKpiGoalType.vue').default,IxBtnDefaultMetricReportingPeriod: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/DefaultMetricReportingPeriod.vue').default})
